import { render, staticRenderFns } from "./TabDestinations.vue?vue&type=template&id=ad5c0dfa&scoped=true&"
import script from "./TabDestinations.vue?vue&type=script&lang=js&"
export * from "./TabDestinations.vue?vue&type=script&lang=js&"
import style0 from "./TabDestinations.vue?vue&type=style&index=0&id=ad5c0dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5c0dfa",
  null
  
)

export default component.exports